import { Location } from '@reach/router';
import React from 'react';

import type { FacilityProps } from './facility-content';
import { FacilityContent } from './facility-content';

const Facility = (props: FacilityProps) => (
  <Location>{({ location }) => <FacilityContent {...props} location={location} />}</Location>
);

export default Facility;
